import { combineReducers } from 'redux'
import { configureStore } from '@reduxjs/toolkit'
import { errorsReducer } from './errors'
import { userReducer } from './user'

const allReducers = combineReducers({
  errors: errorsReducer,
  user: userReducer
})

const store = configureStore({
  reducer: allReducers
})
export default store
